import { KeyboardEventCode } from '@lemonade-hq/cdk';
import { clsx } from 'clsx';
import { useCallback } from 'react';
import type { DateValue } from 'react-aria-components';
import { spacing } from '../../../styles/spacing.css';
import { brandOutline, plainButton } from '../../../styles/utilities.css';
import { Flex } from '../../Flex/Flex';
import { Icon } from '../../Icon/Icon';

interface RightIconProps {
  readonly dateValue: DateValue | null;
  readonly keyboardOnly?: boolean;
  readonly isKeyboard?: boolean;
  readonly handleClear?: () => void;
  readonly showDatePicker?: () => void;
  readonly isCloseIcon?: boolean;
}

export const RightIcon: React.FC<RightIconProps> = ({ handleClear, showDatePicker, isCloseIcon }) => {
  const onKeyDownClear = useCallback(
    (e: React.KeyboardEvent<HTMLButtonElement>): void => {
      if ((e.key as KeyboardEventCode) === KeyboardEventCode.Enter) {
        handleClear?.();
      }
    },
    [handleClear],
  );

  const openDatePicker = useCallback(() => {
    showDatePicker?.();
  }, [showDatePicker]);

  const closeIconProps = {
    name: 'close' as const,
    onClick: handleClear,
    onKeyDown: onKeyDownClear,
  };
  const calendarIconProps = {
    name: 'calendar' as const,
    onClick: openDatePicker,
    onKeyDown: openDatePicker,
  };
  const iconProps = isCloseIcon ? closeIconProps : calendarIconProps;

  return (
    <Flex
      alignItems="center"
      aria-label={iconProps.name}
      as="button"
      className={clsx(plainButton, brandOutline)}
      cursor="pointer"
      flexShrink={0}
      height={spacing.s40}
      justifyContent="center"
      onClick={iconProps.onClick}
      onKeyDown={iconProps.onKeyDown}
      type="button"
      width={spacing.s40}
    >
      <Icon name={iconProps.name} size="md" />
    </Flex>
  );
};
